import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email", "gln", "glnStep", "sendStep", "doctorConfirmation", "doctorName", "notFound", "profileStep", "firstName", "lastName", "channel"];
  static values = { emailLookupUrl: String, glnLookupUrl: String };

  lookupEmail(event) {
    event.preventDefault();
    const email = this.emailTarget.value.trim();
    if(!email) return;

    const url = new URL(this.emailLookupUrlValue, window.location.origin);
    url.searchParams.set("email", email);
    fetch(url.toString(), { headers: { "Accept": "application/json" } })
      .then((response) => response.json())
      .then((data) => this.handleEmailLookup(data));
  }

  lookupGln(event) {
    event.preventDefault();
    const gln = this.glnTarget.value.trim();
    if(!gln) return;

    const url = new URL(this.glnLookupUrlValue, window.location.origin);
    url.searchParams.set("gln", gln);
    fetch(url.toString(), { headers: { "Accept": "application/json" } })
      .then((response) => response.json())
      .then((data) => this.handleGlnLookup(data));
  }

  handleEmailLookup(data) {
    if(data.status === "known") {
      this.glnStepTarget.style.display = "none";
      this.sendStepTarget.style.display = "block";
    } else {
      this.sendStepTarget.style.display = "none";
      this.glnStepTarget.style.display = "block";
      this.glnTarget.focus();
    }
  }

  handleGlnLookup(data) {
    if(data.status === "found") {
      this.notFoundTarget.style.display = "none";
      this.doctorNameTarget.textContent = data.display_name;
      this.firstNameTarget.value = data.first_name || "";
      this.lastNameTarget.value = data.last_name || "";
      this.profileStepTargets.forEach((target) => target.style.display = "block");
      this.firstNameTarget.required = true;
      this.lastNameTarget.required = true;
      this.channelTarget.required = true;
      this.doctorConfirmationTarget.style.display = "block";
      this.sendStepTarget.style.display = "block";
    } else {
      this.profileStepTargets.forEach((target) => target.style.display = "none");
      this.firstNameTarget.required = false;
      this.lastNameTarget.required = false;
      this.channelTarget.required = false;
      this.doctorConfirmationTarget.style.display = "none";
      this.sendStepTarget.style.display = "none";
      this.notFoundTarget.style.display = "block";
    }
  }
}
